import { UNIFORM_PROPS } from 'common/constants/component-props';
import type { BBInheritanceValue, BBStates, StoryMediaPlatform } from 'types/story';

export const getInheritanceInfo = ({
	currentMediaQuery,
	currentState,
	inheritance,
	propertyName,
	propertyPath,
}: {
	currentMediaQuery: StoryMediaPlatform;
	currentState?: BBStates;
	inheritance?: BBInheritanceValue;
	propertyName: string;
	// Dot-notated path to property in story settings "settings.<path>" or commonly in card data "elements.<path>"
	propertyPath: string;
}) => {
	const imq = inheritance?.mq;
	const ist = inheritance?.state;

	const isUniformProp = propertyName in UNIFORM_PROPS || propertyPath?.startsWith('settings.');
	const isDefault = !imq && !ist && !isUniformProp;
	const isInherited = (imq && imq !== currentMediaQuery) || (ist && ist !== currentState);
	const isAssigned = (!isDefault && !isInherited) || isUniformProp;
	const type = isAssigned ? 'assigned' : isInherited ? 'inherited' : 'default';

	return { isDefault, isInherited, isAssigned, isUniformProp, type };
};
